import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, FormSelect, InputGroup } from 'react-bootstrap';

const AdvanceTableSelectSearchBox = ({
  globalFilter,
  setGlobalFilter,
  cursos,
  placeholder = 'Select a course...',
  className,
  setCursuIdFilter
}) => {
  const [value, setValue] = useState(globalFilter);

  const handleChange = (e) => {
    const selectedValue = e.target.value;
    setValue(selectedValue);
    setCursuIdFilter(selectedValue);
    setGlobalFilter(selectedValue); 
  };

  return (
    <InputGroup className={classNames(className, 'position-relative')}>
      <FormSelect
        value={value || ''}
        onChange={handleChange}
        size="sm"
        id="course-select"
        className="shadow-none"
      >
        <option value="">{placeholder}</option>
        {cursos.map((curso) => (
          <option key={curso.id} value={curso.id}>
            {curso.nivel+' - '+curso.horario}
          </option>
        ))}
      </FormSelect>
      <Button
        size="sm"
        variant="outline-secondary"
        className="border-300 hover-border-secondary"
      >
        <FontAwesomeIcon icon="search" className="fs--1" />
      </Button>
    </InputGroup>
  );
};

// Validación de props
AdvanceTableSelectSearchBox.propTypes = {
  globalFilter: PropTypes.string,
  setGlobalFilter: PropTypes.func.isRequired,
  cursos: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      name: PropTypes.string.isRequired
    })
  ).isRequired,
  placeholder: PropTypes.string,
  className: PropTypes.string, 
  setCursuIdFilter: PropTypes.func
};

export default AdvanceTableSelectSearchBox;

